import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import {Button, Container, Menu, Modal} from 'semantic-ui-react';
import {isNoU} from "../../utils/DBUtils";

export default class BasicModal extends React.Component {
  static propTypes = {
    header: PropTypes.any.isRequired,
    actionAlignment: PropTypes.string,
    keepModalOnTop: PropTypes.bool,
    modalProps: PropTypes.object,
    open: PropTypes.bool.isRequired,
    actions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.any.isRequired,
      action: PropTypes.func.isRequired,
      isDisabled: PropTypes.bool,
      displayType: PropTypes.oneOf(['menu-item', 'button'])
    })),
    onClose: PropTypes.func.isRequired,
    dimmer: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string
    ]),
    specialType: PropTypes.string,
    modalSize: PropTypes.string,
    scrolling: PropTypes.bool,
  };

  static defaultProps = {
    actionAlignment: 'right',
    actions: [],
    scrolling: true,
    modalProps: {}
  };

  doKeepModalOnTop = node => {
    if (node) {
      // traverse upward until just before the <body>: this is where
      // Semantic's modal container lives.
      while (node.parentNode !== document.body) {
        node = node.parentNode;
      }

      // keep this modal above any others that may be open.
      node.style.zIndex = '1001';
    }
  };

  getContentRef = node => {
    if (node) {
      this.contentContainer = node.parentNode;
    }
  };

  scrollContentToTop = () => {
    this.contentContainer.scrollTop = 0;
  };

  render() {
    return (
      <Modal
        size={this.props.modalSize}
        open={this.props.open}
        closeIcon
        onClose={this.props.onClose}
        closeOnDimmerClick={this.props.closeOnDimmerClick}
        dimmer={this.props.dimmer}
        className={this.props.specialType}
        {...this.props.modalProps}>
        <Modal.Header>
          {this.props.header}
        </Modal.Header>
        {this.props.keepModalOnTop && (
          <div ref={this.doKeepModalOnTop} style={{display: 'none'}}></div>
        )}
        {this.props.children && (
          <Modal.Content scrolling={this.props.scrolling}>
            <div ref={this.getContentRef}>
              {React.Children.map(get(this, 'props.children', []), child => {
                // if, during navigation between different pages, `props.children` is
                // falsy, then just return whatever is being passed in for `child`.
                return child ? React.cloneElement(child, {
                  scrollContentToTop: this.scrollContentToTop
                }) : child;
              })}
            </div>
          </Modal.Content>
        )}
        {this.props.actions.length > 0 && (
            <Modal.Actions>
              <Container textAlign="right">
                {this.props.actions.map((action, index) => {
                  switch (action.displayType) {
                    case 'menu-item':
                      return (
                        <Menu.Item
                          key={action.label + index}
                          className={action.customStyle}
                          disabled={action.isDisabled}
                          onClick={action.action}>
                          {action.label}
                        </Menu.Item>
                      );
                    case 'button':
                      return (
                        <Button
                          primary={action.primaryCheck}
                          secondary={action.secondaryCheck}
                          key={action.label + index}
                          className={action.customStyle}
                          loading={action.loading}
                          disabled={action.isDisabled}
                          onClick={action.action}>
                          {action.label}
                        </Button>
                      );
                    default:
                      return <div key={action.label + index}>Unknown Display Type</div>;
                  }
                })}
              </Container>
            </Modal.Actions>)}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./public/components/common/BasicModal.jsx